import settings from "@src/settings";
import trimLeading from "@src/utils/trimLeading";
import React from "react";
import styled from "styled-components";

export const Frame = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background-color: #fff;
	border-radius: ${settings.radius.medium}px ${settings.radius.medium}px 0 0;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
`;
export const Title = styled.div`
	text-align: center;
	font-weight: 700;
	font-style: normal;
	font-family: ${settings.font.en};
	color: ${settings.color.main};
	letter-spacing: 3.22px;
	${trimLeading({ fontSize: 17, lineHeight: 1, font: "montserrat" })}
	padding: 32px;
`;
export const List = styled.div`
	flex: 1 1 auto;
	width: 100%;
	padding: 0 32px;
`;
export const Item = styled.a`
	display: flex;
	justify-content: space-between;
	width: 100%;
	text-decoration: none;
	padding: 16px 0;
	& + & {
		border-top: 1px solid ${settings.color.pale};
	}
`;

export const Label = styled.span`
	font-weight: 500;
	font-family: ${settings.font.jp};
	color: ${settings.color.main};
	letter-spacing: 0px;
	${trimLeading({ fontSize: 16, lineHeight: 16 })}
	transform: translateY(-5%);
`;
export const BottomLabel = styled(Label)`
	${trimLeading({ fontSize: 14, lineHeight: 14 })}
`;
export const BottomBar = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 23px 32px;
	border-top: 1px solid ${settings.color.main};
	margin-top: 60px;
`;
export const ToCorporate = styled.a`
	display: flex;
	align-items: center;
	text-decoration: none;
`;
export const NewTabIcon = styled.svg`
	margin-right: 0.5rem;
`;
export const Close = styled.div`
	display: flex;
`;

export const CloseIcon = styled.div`
	position: relative;
	width: 14px;
	height: 14px;
	transform: translateY(1px);
	margin-right: 6px;
	&:before,
	&:after {
		content: "";
		display: block;
		width: 15px;
		height: 2px;
		background-color: ${settings.color.main};
		position: absolute;
		top: 50%;
		left: 50%;
	}
	&:before {
		transform: translate(-50%, -50%) rotate(45deg);
	}
	&:after {
		transform: translate(-50%, -50%) rotate(-45deg);
	}
`;
